// Theme intent handlers (cycle/load + reapply of theme-dependent visuals).

import { INTENTS } from '@store/intents';
import { params } from '@store/instance';
import { applyTheme } from '../theme';
import type { Store } from '@store/store';
import type { State } from '@store/schema';
import type { ViewerContext } from '../context';

export function register(store: Store<State>, viewer: ViewerContext): Array<() => void> {
    const offs: Array<() => void> = [];

    const reapplyThemeDependents = (): void => {
        store.dispatch(INTENTS.SCENE_APPLY_AXIS_GRID);
        store.dispatch(INTENTS.UI_PANE_REFRESH);
    };

    offs.push(store.onIntent(INTENTS.CYCLE_THEME, () => {
        const opts = viewer.theme.options || {};
        const names = Object.keys(opts);
        if (names.length === 0) return;
        const currentName = params.themeName || names[0];
        if (!currentName) return;
        const idx = names.indexOf(currentName);
        const nextName = names[(idx + 1) % names.length];
        if (!nextName) return;
        params.themeName = nextName;
        const url = opts[nextName];
        if (url) (async () => { await applyTheme(viewer, url); reapplyThemeDependents(); })();
    }));

    offs.push(store.onIntent(INTENTS.LOAD_THEME, (p) => {
        if (!p || typeof p.url !== 'string') return;
        const url = p.url;
        (async () => { await applyTheme(viewer, url); reapplyThemeDependents(); })();
    }));

    return offs;
}
